import { render, staticRenderFns } from "./detail_form.vue?vue&type=template&id=1a99f72c&lang=pug"
import script from "./detail_form.vue?vue&type=script&lang=js"
export * from "./detail_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports